import React, { Fragment } from "react";
import { Helmet } from "react-helmet-async";
import withMarketingLayout from "../../../components/desktop/sell-marketing-layout/component";
import MarketingLandingInfo from "../../desktop/sell-marketing-info";
import withReducer from "../../../components/shared/with-reducer";
import injectableReducers from "./injectable";

const MarketingLanding = (props) => {
    return (
        <Fragment>
            <Helmet>
                <title>CARS24 - Sell Your Used car & Get Paid Instantly in Single Visit</title>
                <meta name="ROBOTS" content="NOINDEX,FOLLOW" />
            </Helmet>
            <MarketingLandingInfo {...props} />
        </Fragment>
    );
};
export default withReducer(injectableReducers)(() => {}, dispatch => ({ dispatch }))(withMarketingLayout(MarketingLanding));
